var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAddGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDCBB-ADMIN-(Web)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Parties-prenantes---Clients",
    transform: "translate(-1373.000000, -750.000000)",
    fill: "#848F9D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(898.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(24.000000, 57.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(8.000000, 369.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "447.33 328.334 447.33 324.334 448.67 324.334 448.67 328.334 452.67 328.334 452.67 329.667 448.67 329.667 448.67 333.667 447.33 333.667 447.33 329.667 443.33 329.667 443.33 328.334"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddGrey);
export default __webpack_public_path__ + "static/media/icon_add_grey.9210ea65b11323f33ce54a98cbbc1dc2.svg";
export { ForwardRef as ReactComponent };